"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.balanceProviderActions = exports.initialState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const api_1 = require("../../utils/api");
const payment_1 = require("../../utils/payment");
const constants_1 = require("./constants");
const types_1 = require("./types");
const REDUCER_KEY = 'balanceProvider';
exports.initialState = {
    layout: {
        paymentModalType: null,
        withdrawModalType: types_1.EBalanceWithdrawModalWindowType.OFF,
    },
    data: {
        payment: {
            originUrl: '',
            accountsByWithdrawMethods: {
                fetchItems: api_1.requestInitialState,
                selectedId: undefined,
                entries: {},
            },
            history: {
                items: [],
                hasMore: false,
                fetchItems: api_1.requestInitialState,
            },
            methods: {
                selectedId: undefined,
                items: [],
                fetchItems: api_1.requestInitialState,
            },
            formData: {
                amount: '',
                phone: '',
                webMoney: '',
            },
            createData: {
                fetchInfo: api_1.requestInitialState,
                payment: undefined,
            },
        },
        withdrawal: {
            history: {
                items: [],
                hasMore: false,
                fetchItems: api_1.requestInitialState,
            },
            methods: {
                selectedId: undefined,
                items: [],
                fetchItems: api_1.requestInitialState,
            },
            formData: {
                amount: '',
                [constants_1.PAYMENT_METHODS.MOBILE_PHONE]: '',
                [constants_1.PAYMENT_METHODS.WEB_MONEY]: '',
                [constants_1.PAYMENT_METHODS.CARD]: '',
                [constants_1.PAYMENT_METHODS.EMAIL]: '',
                [constants_1.PAYMENT_METHODS.CRYPTOCURRENCY]: '',
            },
            createData: {
                fetchInfo: api_1.requestInitialState,
                withdrawal: undefined,
                verificationId: '',
                smsCode: '',
            },
        },
        groups: {
            items: [],
            fetchItems: api_1.requestInitialState,
        },
    },
};
const balanceContainerSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        togglePaymentModal(state, { payload }) {
            state.layout.paymentModalType = payload.paymentModalType;
        },
        changeWithdrawModal(state, { payload: { modalType } }) {
            state.layout.withdrawModalType = modalType;
            state.data.withdrawal.createData.fetchInfo.loading = false;
        },
        fetchPayments(state, _action) {
            state.data.payment.history.fetchItems.loading = true;
            state.data.payment.history.fetchItems.error = null;
        },
        fetchPaymentsSuccess(state, { payload }) {
            state.data.payment.history.items = payload.items;
            state.data.payment.history.fetchItems.loading = false;
            state.data.payment.history.fetchItems.error = null;
        },
        fetchPaymentsError(state, { payload }) {
            state.data.payment.history.fetchItems.loading = false;
            state.data.payment.history.fetchItems.error = payload;
        },
        fetchPaymentAccounts(state) {
            state.data.payment.accountsByWithdrawMethods.fetchItems.loading = true;
            state.data.payment.accountsByWithdrawMethods.fetchItems.error = null;
        },
        fetchPaymentAccountsSuccess(state, action) {
            const { resData: paymentAccount, methodId } = action.payload;
            state.data.payment.accountsByWithdrawMethods.fetchItems.loading = false;
            state.data.payment.accountsByWithdrawMethods.fetchItems.error = null;
            state.data.payment.accountsByWithdrawMethods.entries[methodId] =
                paymentAccount.items;
        },
        fetchPaymentAccountsError(state, { payload }) {
            state.data.payment.accountsByWithdrawMethods.fetchItems.loading = false;
            state.data.payment.accountsByWithdrawMethods.fetchItems.error = payload;
        },
        fetchPaymentMethods(state, _action) {
            state.data.payment.methods.fetchItems.loading = true;
            state.data.payment.methods.fetchItems.error = null;
        },
        fetchPaymentMethodsSuccess(state, { payload }) {
            var _a, _b, _c;
            const selectedId = ((_b = (_a = (0, payment_1.groupPaymentMethods)({
                methods: payload.items,
                methodGroups: state.data.groups.items,
            })[0]) === null || _a === void 0 ? void 0 : _a.methods[0]) === null || _b === void 0 ? void 0 : _b.id) || ((_c = payload.items[0]) === null || _c === void 0 ? void 0 : _c.id);
            state.data.payment.methods.items = payload.items;
            if (!payload.items.some((item) => item.id === state.data.payment.methods.selectedId)) {
                state.data.payment.methods.selectedId = selectedId;
            }
            state.data.payment.methods.fetchItems.loading = false;
            state.data.payment.methods.fetchItems.error = null;
        },
        fetchPaymentMethodsError(state, { payload }) {
            state.data.payment.methods.fetchItems.loading = false;
            state.data.payment.methods.fetchItems.error = payload;
        },
        handleChangePaymentMethod(state, { payload }) {
            state.data.payment.methods.selectedId = payload;
        },
        setPaymentFormData(state, { payload }) {
            state.data.payment.formData = {
                ...state.data.payment.formData,
                ...payload,
            };
        },
        createPayment(state) {
            state.data.payment.createData.fetchInfo.loading = true;
            state.data.payment.createData.fetchInfo.error = null;
        },
        createPaymentSuccess(state, { payload }) {
            state.data.payment.createData.payment = payload;
            state.data.payment.createData.fetchInfo.loading = false;
            state.data.payment.createData.fetchInfo.error = null;
        },
        resetPaymentFormData(state) {
            state.data.payment.formData = exports.initialState.data.payment.formData;
        },
        createPaymentError(state, { payload }) {
            state.data.payment.createData.fetchInfo.loading = false;
            state.data.payment.createData.fetchInfo.error = payload;
            state.layout.paymentModalType = types_1.EPaymentModalTypes.Canceled;
        },
        resetPaymentData(state) {
            state.data.payment.createData = exports.initialState.data.payment.createData;
        },
        fetchWithdrawals(state, _action) {
            state.data.withdrawal.history.fetchItems.loading = true;
            state.data.withdrawal.history.fetchItems.error = null;
        },
        fetchWithdrawalsSuccess(state, { payload }) {
            state.data.withdrawal.history.items = payload.items;
            state.data.withdrawal.history.fetchItems.loading = false;
            state.data.withdrawal.history.fetchItems.error = null;
        },
        fetchWithdrawalsError(state, { payload }) {
            state.data.withdrawal.history.fetchItems.loading = false;
            state.data.withdrawal.history.fetchItems.error = payload;
        },
        fetchWithdrawalMethods(state, _action) {
            state.data.withdrawal.methods.fetchItems.loading = true;
            state.data.withdrawal.methods.fetchItems.error = null;
        },
        fetchWithdrawalMethodsSuccess(state, { payload }) {
            var _a, _b;
            const selectedId = (_b = (_a = (0, payment_1.groupPaymentMethods)({
                methods: payload.items,
                methodGroups: state.data.groups.items,
            })[0]) === null || _a === void 0 ? void 0 : _a.methods[0]) === null || _b === void 0 ? void 0 : _b.id;
            state.data.withdrawal.methods.items = payload.items;
            state.data.withdrawal.methods.selectedId = selectedId;
            state.data.withdrawal.methods.fetchItems.loading = false;
            state.data.withdrawal.methods.fetchItems.error = null;
        },
        fetchWithdrawalMethodsError(state, { payload }) {
            state.data.withdrawal.methods.fetchItems.loading = false;
            state.data.withdrawal.methods.fetchItems.error = payload;
        },
        handleChangeWithdrawalMethod(state, { payload }) {
            state.data.withdrawal.methods.selectedId = payload;
        },
        handleChangePaymentAccount(state, { payload }) {
            state.data.payment.accountsByWithdrawMethods.selectedId = payload;
        },
        setWithdrawalFormData(state, { payload }) {
            state.data.withdrawal.formData = {
                ...state.data.withdrawal.formData,
                ...payload,
            };
        },
        createWithdrawal(state) {
            state.data.withdrawal.createData.fetchInfo.loading = true;
            state.data.withdrawal.createData.fetchInfo.error = null;
        },
        createWithdrawalSuccess(state, { payload }) {
            state.data.withdrawal.createData.withdrawal = payload;
            state.data.withdrawal.formData = exports.initialState.data.withdrawal.formData;
            state.data.withdrawal.createData.fetchInfo.loading = false;
            state.data.withdrawal.createData.fetchInfo.error = null;
        },
        createWithdrawalError(state, { payload }) {
            state.data.withdrawal.createData.fetchInfo.loading = false;
            state.data.withdrawal.createData.fetchInfo.error = payload;
        },
        createWithdrawalErrorClear(state) {
            state.data.withdrawal.createData.fetchInfo.error = null;
        },
        fetchPaymentMethodGroups(state) {
            state.data.groups.fetchItems.loading = true;
            state.data.groups.fetchItems.error = null;
        },
        fetchPaymentMethodGroupsSuccess(state, { payload }) {
            state.data.groups.items = payload.items;
            state.data.groups.fetchItems.loading = false;
            state.data.groups.fetchItems.error = null;
        },
        fetchPaymentMethodGroupsError(state, { payload }) {
            state.data.groups.fetchItems.loading = false;
            state.data.groups.fetchItems.error = payload;
        },
        setOriginUrl(state, { payload }) {
            state.data.payment.originUrl = payload.url;
        },
        fetchVerificationIdentifier(state) {
            state.data.withdrawal.createData.fetchInfo.loading = true;
            state.data.withdrawal.createData.fetchInfo.error = null;
        },
        fetchVerificationIdentifierSuccess(state, { payload }) {
            state.data.withdrawal.createData.verificationId = payload.id;
            state.data.withdrawal.createData.fetchInfo.loading = false;
            state.data.withdrawal.createData.fetchInfo.error = null;
        },
        fetchVerificationIdentifierError(state, { payload }) {
            state.data.withdrawal.createData.fetchInfo.loading = false;
            state.data.withdrawal.createData.fetchInfo.error = payload;
        },
        setWithdrawalSmsCode(state, { payload }) {
            state.data.withdrawal.createData.smsCode = payload;
        },
    },
});
exports.balanceProviderActions = balanceContainerSlice.actions, exports.reducer = balanceContainerSlice.reducer, exports.sliceKey = balanceContainerSlice.name;
//# sourceMappingURL=slice.js.map